import * as React from "react";
import { List, Datagrid, TextField, BooleanField, ChipField, TopToolbar, ExportButton } from 'react-admin';

const ListActions = () => (
    <TopToolbar>
        <ExportButton maxResults={200} />
    </TopToolbar>
);
export const UserList = props => (
    <List {...props} actions={<ListActions />} bulkActionButtons={true}>
        <>
            <h2>Users list</h2>
            <Datagrid rowClick="show" bulkActionButtons={false}>
                <TextField source="id" />
                <TextField source="firstName" />
                <TextField source="lastName" />
                <TextField source="email" />
                <TextField source="phoneNumber" />
                <BooleanField source="isLockedOut" />
                <ChipField label="User role" source="userRole.name" />
            </Datagrid>
        </>
    </List>
);
